import {Box, TextField, Typography} from "@mui/material";
import {COLORS} from "../../../ui/Theme";

const inputLabel = {
    color: COLORS.BLACK,
    fontSize: "14px",
    fontWeight: 400,
    marginBottom: "10px",
}

const ProfileTextfield = ({label, ...props}) => {

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
            }}
        >
            <Typography sx={inputLabel}>{label}</Typography>
            <TextField{...props}/>
        </Box>
    );
};

export default ProfileTextfield;